export default __webpack_public_path__ + "df2d747dcff52bd8af34932ecc0b13f1.svg";